<template>
  <div class="overflow-hidden">
    <div class="flex items-center justify-items-center">
      <a-upload
        :file-list="fileList"
        class="avatar-uploader"
        :before-upload="beforeUpload"
        :customRequest="api"
        :accept="accept"
        :disabled="disabled"
        :remove="removeFile"
      >
        <a-button> <a-icon type="upload" /> 上传合同 </a-button>
      </a-upload>
    </div>
    <!-- <div
      v-if="!disabled"
      class="float-left w-8 px-1 leading-8 text-center text-white bg-blue-700 rounded-r cursor-pointer hover:bg-blue-800"
      style="height: 128px"
      @click="getQrcode"
    >
      扫码上传
    </div> -->
    <a-modal
      title="扫码上传"
      :visible="qrcodeFlag"
      :footer="null"
      @cancel="qrcodeFlag = false"
      forceRender
    >
      <div class="m-auto my-4"> 您可通过手机扫描下方二维码快捷上传对应的材料 </div>
      <div class="m-auto">
        <div id="qrcode" ref="qrcode"></div>
      </div>
    </a-modal>
  </div>
</template>
<script>
  import { v4 as uuidv4 } from 'uuid';
  import QRCode from 'qrcodejs2';
  import { resourceByUUID } from '@/api/resource';

  export default {
    props: {
      accept: {
        default: 'image/*,.doc,.docx',
        type: String,
      },
      src: String,
      disabled: Boolean,
      ct: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        imgsrc: '',
        loading: false,
        uuid: '',
        qrcodeUrl: '',
        qrcodeFlag: false,
        qrcode: '',
        timer: null,
        fileList: [],
      };
    },
    mounted() {
      this.imgsrc = this.src;
    },
    watch: {
      qrcodeFlag(a) {
        if (a) {
          this.timer = setInterval(async () => {
            if (this.uuid) {
              let data = await resourceByUUID(this.uuid);
              if (data.pathname != '') {
                clearInterval(this.timer);
                this.qrcodeFlag = false;
                this.$emit('upload', data);
              }
            }
          }, 1000);
        } else {
          if (this.timer) {
            clearInterval(this.timer);
          }
        }
      },
      src(a) {
        this.imgsrc = a;
      },
      ct(a) {
        this.fileList = a.contract_r_file.map((v) => {
          return {
            uid: v.id,
            name: v.pathname,
            url: this.$ossUrl + v.pathname,
            status: 'done',
          };
        });
        console.log(1232);
      },
    },
    methods: {
      beforeUpload(file) {
        const isLt = file.size / 1024 / 1024 < 50;
        if (!isLt) {
          this.$message.error('上传文件需小于50MB!');
          return false;
        }
        return isLt;
      },
      async api(e) {
        let formData = new FormData();
        formData.append('file', e.file);
        formData.append('where', 'license');
        formData.append('style', '1');
        this.loading = true;
        let res = await this.$uploadfile('/api/v1/file_upload', formData);
        this.imgsrc = res.pathname;
        // this.$emit('upload', res);
        this.loading = false;
        // let list = [];
        this.fileList.push({
          uid: res.id,
          name: res.filename,
          url: this.$ossUrl + res.pathname,
          status: 'done',
        });
        this.$emit('upload', this.fileList);
        // this.fileList = list;
        // console.log(this.fileList);
      },
      removeFile(file) {
        const index = this.fileList.indexOf(file.file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
        this.$emit('upload', this.fileList);
      },
      getQrcode() {
        this.uuid = uuidv4();
        this.qrcodeUrl =
          'https://' + window.location.host + '/api/v1/upload_file_by_qr/' + this.uuid;
        // this.qrcodeUrl = 'http://192.168.28.73:9091' + '/api/v1/upload_file_by_qr/' + this.uuid;
        if (this.qrcode) {
          this.$refs['qrcode'].innerHTML = '';
        }
        this.qrcode = new QRCode(this.$refs['qrcode'], {
          text: this.qrcodeUrl,
          width: 300,
          height: 300,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        });
        this.qrcodeFlag = true;
      },
    },
  };
</script>
<style lang="less" scoped>
  .avatar-uploader {
    display: flex;
    .ant-upload {
      height: 32px !important;
    }
  }
</style>
<style scoped>
  :deep(.ant-upload-btn) {
    padding: 0 !important;
  }
</style>
